import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Input } from "antd";
const FormServiceFieldTechnicalDefinitionsCookiePurpose = ({ field, readOnly })=>{
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        name: [
            field.name,
            "purpose"
        ],
        children: /*#__PURE__*/ _jsx(Input.TextArea, {
            disabled: readOnly,
            rows: 1,
            autoSize: {
                maxRows: 3
            }
        })
    });
};
export { FormServiceFieldTechnicalDefinitionsCookiePurpose };
